import { formatMoney } from '../../components/Utils/FormatUtils';

/**
 * Formats partagés par la page « Avances et prêts » et ses sections.
 */

/**
 * Mois en clair — « octobre 2026 » plutôt que « 2026-10 ».
 *
 * Retourne la valeur brute si elle n'est pas exploitable : mieux vaut le code
 * du contrat qu'un « Invalid Date » au milieu d'une liste.
 */
export function formaterMois(mois, locale) {
  if (typeof mois !== 'string' || !/^\d{4}-\d{2}$/.test(mois)) {
    return mois || '';
  }
  const date = new Date(`${mois}-01T00:00:00`);
  if (Number.isNaN(date.getTime())) {
    return mois;
  }
  return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(date);
}

/**
 * Jour en clair — « 18 sept. 2026 » — à partir de « 2026-09-18 » ou d'une date
 * Odoo « 2026-09-18 10:02:00 », découpée plutôt que convertie : un passage par
 * l'UTC décalerait d'un jour une demande déposée en soirée.
 */
export function formaterJour(valeur, locale) {
  if (typeof valeur !== 'string' || !/^\d{4}-\d{2}-\d{2}/.test(valeur)) return '—';
  const date = new Date(`${valeur.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
}

/**
 * Un montant avec sa devise, ou « — » s'il n'y en a pas.
 *
 * « 16 666 » seul ne dit pas de quoi l'on parle (Yros/Kavero#410, #413), et il
 * s'écrit dans la langue de l'utilisateur. Un montant absent s'écrit « — », jamais « 0 F CFA » qui dirait « soldé ».
 */
export function formaterMontant(montant, locale) {
  if (typeof montant !== 'number' || !Number.isFinite(montant)) {
    return '—';
  }
  return formatMoney(montant, locale);
}
